<script setup lang="ts">
  import { FlowContactsWidget } from '@/widgets/Flow'
  import { useApiRequestsAbort } from '@/shared/composables'
  import { TravelDirection } from '@/shared/types/common.types'

  useApiRequestsAbort()
</script>

<template>
  <FlowContactsWidget :type-of-travel="TravelDirection.INBOUND" />
</template>
